if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"shell","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return /^(1(4(32|65|94)|6(12|70|99)|(33|59|73)3|012|185|268|317|924|981)|2(057|153|501|6|698|75|892)|3((10|22|66)8|170|456|517|643|746)|4(6(24|39|72)|117|344|36|545|860)|5(6(6|61|84)|7(0|04|77)|023|201|309|464|54|80|872)|6(35[15]|5(15|7|75)|114|429|480|658|747|798)|7(9(47|63|79)||02|19|27|321|401|43|603|650|780)|8(1(03|28|86)|4(5|7|97)||041|060|592|661|849|95)|9(4(09|37|87)|039|075|293|352|37|641|687|756|815))$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}